import React,{useEffect} from 'react'
import SidebarInf03 from '../../components/sidebar/SidebarInf03'
import 'highlight.js/styles/atom-one-dark.css';
import hljs from 'highlight.js';

const Skrjs = () => {

  useEffect(() => {
    hljs.addPlugin({
        'after:highlightElement': ({ result, el }) => {
            const lines = document.createElement('div');
            if (!result.value.includes('<span class="line-num">')) {
                lines.innerHTML = result.value.replace(/^/gm, '<span class="line-num"></span>');
            }
            el.replaceChildren(...lines.childNodes);
        }
    });


    if (!document.querySelector('.hljs')) {
      hljs.highlightAll();
  }
   
  });


  return (
    <div id='rozwiazaniainf03'>

    <SidebarInf03></SidebarInf03>

        <div id="rozwiazanieustawienie">
          <div id="rozwiazanie" style={{ padding: '20px', maxWidth: '900px', margin: 'auto', textAlign: "left" }}>
            <h1>Skrypt JavaScript</h1>
            <hr></hr>
            <section>
              <h2>Słowem wstępu</h2>
              <blockquote class="introduction">
                <strong>Ważne info</strong>
                Tutaj znajdziesz szybki skrót informacji z javascript, które pojawiły się na egzaminie. Nie nauczę cię Tutaj
                javascript , a jedynie chce przypomnieć najważniejsze rzeczy. Jeśli chciałbyś zgłębić wiedzę polecam kursy na youtube
                za darmo albo kursjs.pl.
              </blockquote>
            </section>
            <section>
              <h2>Spis Treści</h2>
              <ol className='listmargin'>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptjs">Zmienne w JavaScript</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptjs#inswarunkowe">Instrukcje Warunkowe</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptjs#petlejs">Pętle w Javascript</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptjs#funjs">Funkcje w JavaScript</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptjs#domjs">Manipulacje DOM w JavaScript</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptjs#addlistenerjs">Metoda addEventListener</a></li>
                <li><a href="/EgzaminyZawodoweINF/#/egzaminy/inf03/skryptjs#obdatejs">Obiket Date()</a></li>
              
              </ol>
            </section>
            <hr />
            <section>
              <h1>Zmienne</h1>
              <p>Zmienne w JavaScript służą do przechowywania danych.
                 Można je deklarować za pomocą var, let oraz const. Każde z tych słów kluczowych ma specyficzne cechy i zastosowania.</p>
              <h4>var</h4>
              <p>var: używane głównie w starszym kodzie, zakres globalny lub funkcji.</p>
              <pre><code>{`var x = 10;
console.log(x); // 10

function myFunction() {
  var y = 5;
  console.log(y); // 5
}
myFunction();`}</code></pre>
              <h4>let</h4>
              <p>Zmienne zadeklarowane za pomocą let mają zakres blokowy, co oznacza, że są widoczne tylko wewnątrz bloku, w którym zostały zadeklarowane.</p>
              <pre><code>{`let x = 10;
if (true) {
  let x = 20;
  console.log(x); // Wyświetli 20
}
console.log(x); // Wyświetli 10`}</code></pre>
              <h4>const</h4>
              <p> Jest używane do deklarowania zmiennych, których wartości nie mogą być zmieniane po ich stworzeniu (definicji). Zmienne const mają zakres blokowy, podobnie jak let. Należy jednak pamiętać, że const zapewnia niezmienność odniesienia, a nie wartości.
                 Oznacza to, że jeśli zmienna const przechowuje obiekt, zawartość tego obiektu może być zmieniana.</p>
                 <pre><code>{`const x = 10;
// x = 20; // Błąd: Assignment to constant variable

const osoba = { imie: "John", wiek: 30 };
osoba.wiek = 41; // To jest dozwolone
console.log(osoba); // Wyświetli { imie: "John", wiek: 41 }`}</code></pre>
            </section>
            <hr />
            <section>
              <h2>Instrukcje warunkowe: if i switch</h2>
              <p>Instrukcje warunkowe są kluczowym elementem programowania, umożliwiającym podejmowanie decyzji w kodzie na podstawie warunków.
                 W JavaScript do najczęściej używanych instrukcji warunkowych należą if i switch.</p>
                 <h4>Instrukcja if</h4>
                 <p>Instrukcja if sprawdza, czy warunek jest prawdziwy (true), i jeśli tak, wykonuje określony blok kodu. Można również użyć else oraz else if, aby określić alternatywne bloki kodu do wykonania, gdy warunek jest fałszywy (false).</p>
                 <pre><code>{`let ocena = 85;

if (ocena >= 90) {
    console.log("Ocena: A");
} else if (ocena >= 80) {
    console.log("Ocena: B");
} else if (ocena >= 70) {
    console.log("Ocena: C");
} else if (ocena >= 60) {
    console.log("Ocena: D");
} else {
    console.log("Ocena: F");
}`}</code></pre>
<h4>Instrukcja switch</h4>
<p>Instrukcja switch jest używana do wybierania jednego z wielu bloków kodu do wykonania, na podstawie wartości zmiennej lub wyrażenia. switch jest bardziej czytelny i uporządkowany w przypadku, gdy trzeba sprawdzić wiele wartości jednej zmiennej.</p>
<pre><code>{`let kolor = "czerwony";

switch (kolor) {
    case "czerwony":
        console.log("Kolor jest czerwony");
        break;
    case "niebieski":
        console.log("Kolor jest niebieski");
        break;
    case "zielony":
        console.log("Kolor jest zielony");
        break;
    default:
        console.log("Nieznany kolor");
}`}</code></pre>
            </section>
            <hr />
            <section>
              <h2>Pętle w JS</h2>
              <p>Pętle są kluczowym narzędziem programowania, pozwalającym na wielokrotne wykonanie bloku kodu.
                 JavaScript oferuje kilka rodzajów pętli: for, while, do...while, a także nowsze iteracyjne pętle for...of i for...in.</p>
                 <h4>Pętla for</h4>
                 <p>Pętla for jest najbardziej uniwersalna i pozwala na precyzyjne sterowanie iteracjami. 
                  Składa się z trzech części: inicjalizacji, warunku i wyrażenia aktualizującego.</p>
                 <pre><code>{`for (let i = 0; i < 5; i++) {
    console.log(i);
}
// Wynik: 0, 1, 2, 3, 4`}</code></pre>
                  <h4>Pętla while</h4>
                 <p>Pętla while wykonuje blok kodu tak długo, jak długo warunek jest prawdziwy (true). 
                  Warunek jest sprawdzany przed każdą iteracją.</p>
                 <pre><code>{`let i = 0;
while (i < 5) {
    console.log(i);
    i++;
}
// Wynik: 0, 1, 2, 3, 4`}</code></pre>
<h4>Pętla do...while</h4>
                 <p>Pętla do...while jest podobna do while, 
                  ale warunek jest sprawdzany po każdej iteracji, co gwarantuje, że blok kodu zostanie wykonany przynajmniej raz.</p>
                 <pre><code>{`let i = 0;
do {
    console.log(i);
    i++;
} while (i < 5);
// Wynik: 0, 1, 2, 3, 4`}</code></pre>
<h4>Pętla for...of</h4>
                 <p>Pętla for...of służy do iteracji po wartościach iterowalnych obiektów,
                   takich jak tablice, mapy, zbiory, ciągi znaków itp.</p>
                 <pre><code>{`const tablica = [10, 20, 30, 40, 50];
for (let wartosc of tablica) {
    console.log(wartosc);
}
// Wynik: 10, 20, 30, 40, 50`}</code></pre>
<h4>Pętla for...in</h4>
                 <p>Pętla for...in służy do iteracji po właściwościach obiektu.
                   Nie jest zalecana do iteracji po tablicach, ponieważ iteruje po nazwach właściwości, a nie wartościach.</p>
                 <pre><code>{`const obiekt = {a: 1, b: 2, c: 3};
for (let klucz in obiekt) {
    console.log(""+klucz + ":" + obiekt[klucz]+"");
}
// Wynik: a: 1, b: 2, c: 3`}</code></pre>
            </section>
            <hr />
            <section>
              <h2>Funkcje w Javascript</h2>
              <p>Funkcje w JavaScript są fundamentalnym elementem programowania, umożliwiającym grupowanie kodu w zorganizowane, wielokrotnego użytku bloki. Funkcje mogą przyjmować argumenty, zwracać wartości i być zdefiniowane na wiele sposobów.
</p>
<h4>Tradycyjna funkcja</h4>
<p>Najbardziej tradycyjny sposób definiowania funkcji. 
  Funkcje zdefiniowane w ten sposób są hoistowane, co oznacza, że można ich używać przed ich deklaracją w kodzie.</p>
  <pre><code>{`function nazwaFunkcji(parametr1, parametr2) {
    // Kod do wykonania
    return parametr1 + parametr2;
}

// Wywołanie funkcji
let wynik = nazwaFunkcji(5, 10);
console.log(wynik); // Wypisuje: 15`}</code></pre>
<h4>Funkcje anonimowe (wyrażenia funkcyjne)</h4>
<p>Funkcje mogą być również zdefiniowane jako wyrażenia i przypisane do zmiennych. Funkcje te nie są hoistowane.</p>
<pre><code>{`const nazwaFunkcji = function(parametr1, parametr2) {
    return parametr1 + parametr2;
};

let wynik = nazwaFunkcji(5, 10);
console.log(wynik); // Wypisuje: 15`}</code></pre>
<h4>Funkcje strzałkowe (arrow functions)</h4>
<p>Wprowadzone w ES6, funkcje strzałkowe mają bardziej zwięzłą składnię i nie posiadają własnego kontekstu this.</p>
<pre><code>{`const nazwaFunkcji = (parametr1, parametr2) => {
    return parametr1 + parametr2;
};

// Jeszcze bardziej skrócona forma dla prostych wyrażeń
const nazwaFunkcjiKrotka = (parametr1, parametr2) => parametr1 + parametr2;

let wynik = nazwaFunkcji(5, 10);
console.log(wynik); // Wypisuje: 15`}</code></pre>
<h4>Wartości domyślne parametrów</h4>
<p>Od ES6 można przypisywać wartości domyślne do parametrów funkcji.</p>
<pre><code>{`function powitanie(imie = "Nieznajomy") {
    console.log("Witaj, " + imie + "!");
}

powitanie(); // Wypisuje: Witaj, Nieznajomy!
powitanie("Jan"); // Wypisuje: Witaj, Jan!`}</code></pre>
<h4>Funkcje jako obiekty</h4>
<p>W JavaScript funkcje są obiektami, co oznacza, 
  że mogą być przechowywane w zmiennych, przekazywane jako argumenty do innych funkcji i zwracane przez inne funkcje.</p>
  <pre><code>{`function operacjaMatematyczna(a, b, operacja) {
    return operacja(a, b);
}

function dodaj(a, b) {
    return a + b;
}

function mnoz(a, b) {
    return a * b;
}

console.log(operacjaMatematyczna(5, 10, dodaj)); // Wypisuje: 15
console.log(operacjaMatematyczna(5, 10, mnoz)); // Wypisuje: 50`}</code></pre>
<pre><code>{`function powitaj(nazwa) {
    return function(imie) {
        console.log("Witaj, " + imie + "! Jesteś w " + nazwa + ".");
    };
}

const powitajWDomu = powitaj("domu");
powitajWDomu("Jan"); // Wypisuje: Witaj, Jan! Jesteś w domu.`}</code></pre>
<h4>Rekurencja</h4>
<p>Funkcja może wywoływać samą siebie, co nazywane jest rekurencją. 
  Rekurencja jest przydatna do rozwiązywania problemów, które mogą być podzielone na mniejsze, podobne do siebie problemy.</p>
  <pre><code>{`function silnia(n) {
    if (n <= 1) {
        return 1;
    } else {
        return n * silnia(n - 1);
    }
}

console.log(silnia(5)); // Wypisuje: 120`}</code></pre>
<h4>Funkcje natychmiastowo wywoływane (IIFE)</h4>
<p>Funkcje natychmiastowo wywoływane (Immediately Invoked Function Expressions) są definiowane i wywoływane jednocześnie. Są one używane do tworzenia zakresu lokalnego.</p>
<pre><code>{`(function() {
    console.log("To jest IIFE!");
})();`}</code></pre>
<h4>Parametry resztkowe (Rest Parameters) w JavaScript</h4>
<p>Parametry resztkowe (Rest Parameters) są funkcją wprowadzoną w ES6, 
  która pozwala na przekazanie nieokreślonej liczby argumentów do funkcji jako tablicy. Używa się do tego operatora ... (trzy kropki), 
  który zbiera wszystkie nadmiarowe argumenty przekazane do funkcji i umieszcza je w tablicy.</p>
  <pre><code>{`function dodaj(...liczby) {
    let suma = 0;
    for (let liczba of liczby) {
        suma += liczba;
    }
    return suma;
}

console.log(dodaj(1, 2, 3)); // Wypisuje: 6
console.log(dodaj(1, 2, 3, 4, 5)); // Wypisuje: 15`}</code></pre>
            </section>
            <hr />
            <section>
              <h2>Manipulacje DOM w JavaScript</h2>
              <p>DOM (Document Object Model) jest strukturą dokumentu HTML, którą można modyfikować za pomocą JavaScript. 
                Manipulacje DOM pozwalają na dynamiczne zmiany w strukturze, stylu i zawartości strony internetowej.</p>
                <h4>Podstawowe operacje na DOM</h4>
                <pre><code>{`//Zwraca element o określonym identyfikatorze (ID).
const element = document.getElementById('moj-element');
const pierwszyElement = document.querySelector('#moj-element');

//Zmiana zawartości elementów

  //Zmienia tylko tekst wewnątrz elementu.
const element = document.getElementById('moj-element');
element.textContent = 'Nowy tekst';

 //Zmienia HTML wewnątrz elementu, umożliwiając wstawianie znaczników HTML.
const element = document.getElementById('moj-element');
element.innerHTML = '<strong>Nowa zawartość</strong>';

 //Atrybuty elementów HTML można modyfikować za pomocą metod getAttribute i setAttribute.
const obrazek = document.getElementById('moj-obrazek');
obrazek.setAttribute('src', 'nowy-obrazek.jpg');

 //Możesz zmieniać style elementów za pomocą właściwości style.
const element = document.getElementById('moj-element');
element.style.color = 'red';
element.style.fontSize = '20px';`}</code></pre>
<h4>Manipulacje strukturalne</h4>
<p>Możesz tworzyć nowe elementy i dodawać je do dokumentu za pomocą metod createElement i appendChild.</p>
<pre><code>{`const nowyElement = document.createElement('div');
nowyElement.textContent = 'Jestem nowym elementem';
document.body.appendChild(nowyElement);`}</code></pre>
<p>Aby usunąć element, możesz użyć metody removeChild.</p>
<pre><code>{`const rodzic = document.getElementById('rodzic');
const dziecko = document.getElementById('dziecko');
rodzic.removeChild(dziecko);`}</code></pre>
<p>Możesz dodawać, usuwać i przełączać klasy CSS za pomocą metod classList.</p>
<pre><code>{`const element = document.getElementById('moj-element');
element.classList.add('nowa-klasa');
element.classList.remove('stara-klasa');
element.classList.toggle('ukryty');`}</code></pre>
            </section>
            <hr />
            <section>
              <h2>Metoda addEventListener</h2>
              <p>Dodawanie zdarzeń do elementów umożliwia reagowanie na interakcje użytkownika.</p>
              <pre><code>{`const przycisk = document.getElementById('moj-przycisk');
przycisk.addEventListener('click', function() {
    alert('Przycisk został kliknięty!');
});`}</code></pre>
<p>Przykład: Obsługa zdarzenia kliknięcia przycisku z wykorzystaniem dwóch inputów</p>
<pre><code>{`<!DOCTYPE html>
<html lang="pl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Sumowanie liczb</title>
</head>
<body>
    <h1>Sumowanie dwóch liczb</h1>
    <input type="number" id="liczba1" placeholder="Wprowadź pierwszą liczbę">
    <input type="number" id="liczba2" placeholder="Wprowadź drugą liczbę">
    <button id="sumuj">Oblicz sumę</button>
    <p id="wynik"></p>

    <script src="skrypt.js"></script>
</body>
</html>`}</code></pre>
<pre><code>{`// Uzyskanie dostępu do elementów DOM
const input1 = document.getElementById('liczba1');
const input2 = document.getElementById('liczba2');
const button = document.getElementById('sumuj');
const wynikElement = document.getElementById('wynik');

// Funkcja obliczająca sumę
function obliczSume() {
    // Pobranie wartości z inputów i zamiana ich na liczby
    const liczba1 = parseFloat(input1.value);
    const liczba2 = parseFloat(input2.value);

    // Sprawdzenie, czy wartości są liczbami
    if (isNaN(liczba1) || isNaN(liczba2)) {
        wynikElement.textContent = 'Proszę wprowadzić poprawne liczby.';
        return;
    }

    // Obliczenie sumy
    const suma = liczba1 + liczba2;

    // Wyświetlenie wyniku
    wynikElement.textContent = 'Suma: ' + suma;
}

// Dodanie obsługi zdarzenia kliknięcia do przycisku
button.addEventListener('click', obliczSume);`}</code></pre>
            </section>
            <hr />
            <section>
              <h2>Obiekt Date w JavaScript</h2>
              <p>Obiekt Date w JavaScript służy do pracy z datami i czasem. 
                Pozwala na tworzenie, modyfikowanie i formatowanie dat oraz wykonywanie operacji związanych z czasem.
                 Poniżej omówione są podstawowe i zaawansowane metody korzystania z obiektu Date.</p>
                 <pre><code>{`// 1. Tworzenie obiektu Date

// Bez argumentów - aktualna data i czas
const teraz = new Date();
console.log(teraz); // Wypisuje aktualną datę i czas

// Z argumentami - konkretny rok, miesiąc, dzień, godzina, minuta, sekunda, milisekunda
const konkretnaData = new Date(2023, 5, 29, 14, 30, 0, 0);
console.log(konkretnaData); // Wypisuje: Thu Jun 29 2023 14:30:00 GMT+0000

// Milisekundy od 1 stycznia 1970 (UNIX Epoch)
const dataZMilisekund = new Date(1672531199000);
console.log(dataZMilisekund); // Wypisuje datę odpowiadającą podanej liczbie milisekund

// Data w formacie łańcuchowym
const dataString = new Date('June 29, 2023 14:30:00');
console.log(dataString); // Wypisuje: Thu Jun 29 2023 14:30:00 GMT+0000

// 2. Pobieranie poszczególnych części daty

// Zwraca rok
const rok = teraz.getFullYear();
console.log(rok); // Wypisuje: 2024

// Zwraca miesiąc (0-11)
const miesiac = teraz.getMonth();
console.log(miesiac); // Wypisuje: 5 dla czerwca

// Zwraca dzień miesiąca (1-31)
const dzien = teraz.getDate();
console.log(dzien); // Wypisuje: 29

// Zwraca dzień tygodnia (0-6, gdzie 0 to niedziela)
const dzienTygodnia = teraz.getDay();
console.log(dzienTygodnia); // Wypisuje: 4 dla czwartku

// Zwraca godzinę, minutę, sekundę, milisekundę
const godzina = teraz.getHours();
const minuta = teraz.getMinutes();
const sekunda = teraz.getSeconds();
const milisekunda = teraz.getMilliseconds();
console.log(godzina, minuta, sekunda, milisekunda); // Wypisuje aktualny czas

// 3. Ustawianie poszczególnych części daty

// Ustawienie roku, miesiąca, dnia, godziny, minuty, sekundy
const data = new Date();
data.setFullYear(2025);
data.setMonth(11); // Grudzień
data.setDate(25);
data.setHours(10);
data.setMinutes(30);
data.setSeconds(15);
console.log(data); // Wypisuje: Thu Dec 25 2025 10:30:15 GMT+0000

// 4. Formatowanie dat

// Zwraca część daty jako czytelny łańcuch znaków
const dataStringFormatted = teraz.toDateString();
console.log(dataStringFormatted); // Wypisuje: Thu Jun 29 2023

// Zwraca część czasu jako czytelny łańcuch znaków
const czasString = teraz.toTimeString();
console.log(czasString); // Wypisuje: 14:30:00 GMT+0000 (czas lokalny)

// Zwraca datę w formacie lokalnym
const dataLokalna = teraz.toLocaleDateString();
console.log(dataLokalna); // Wypisuje: 29/6/2023 w formacie lokalnym (np. dd/mm/yyyy)

// Zwraca czas w formacie lokalnym
const czasLokalny = teraz.toLocaleTimeString();
console.log(czasLokalny); // Wypisuje: 14:30:00 w formacie lokalnym

// Zwraca datę w formacie ISO (UTC)
const isoString = teraz.toISOString();
console.log(isoString); // Wypisuje: 2023-06-29T14:30:00.000Z

// 5. Operacje na datach

// Tworzenie dwóch dat do porównania
const data1 = new Date('2023-06-29');
const data2 = new Date('2024-06-29');

// Porównywanie dat
console.log(data1 < data2); // Wypisuje: true
console.log(data1.getTime() === data2.getTime()); // Wypisuje: false

// Dodawanie i odejmowanie czasu
const dataManipulacja = new Date();
dataManipulacja.setDate(dataManipulacja.getDate() + 5); // Dodaje 5 dni
console.log(dataManipulacja);

dataManipulacja.setHours(dataManipulacja.getHours() - 3); // Odejmowanie 3 godzin
console.log(dataManipulacja);

// 6. Tworzenie odliczania

// Funkcja obliczająca różnicę między dwiema datami
// Uwaga przy returnie napisz $ razem z nawiasami
function odliczanie(docelowaData) {
    const teraz = new Date();
    const roznica = docelowaData - teraz;

    const dni = Math.floor(roznica / (1000 * 60 * 60 * 24));
    const godziny = Math.floor((roznica % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minuty = Math.floor((roznica % (1000 * 60 * 60)) / (1000 * 60));
    const sekundy = Math.floor((roznica % (1000 * 60)) / 1000);

    return $ {dni} dni, $ {godziny} godzin, $ {minuty} minut, $ {sekundy} sekund";
}

// Data docelowa do odliczania
const docelowaData = new Date('2024-12-31T23:59:59');
console.log(odliczanie(docelowaData));`}</code></pre>
            </section>
          </div>
        </div>
    </div>
  )
}


export default Skrjs